
import { Property } from "../types/propertyTypes";
export const getAllPropertyImages = (
  property: Property
): Array<{ url: string; label: string }> => {
  const images: Array<{ url: string; label: string }> = [];

  // Use propertyPhotos as the primary source if available
  if (property.propertyPhotos && Array.isArray(property.propertyPhotos)) {
    return property.propertyPhotos
      .filter((photo: any) => photo.url)
      .map((photo: any, index) => ({
        url: photo.url,
        label: photo.label || `Property Image ${index + 1}`,
      }));
  }

  // Fallback to individual image fields only if propertyPhotos is empty
  const imageFields = [
    { field: property.frontView, label: "Front View" },
    { field: property.backView, label: "Back View" },
    { field: property.leftView, label: "Left View" },
    { field: property.rightView, label: "Right View" },
    { field: property.livingRoom, label: "Living Room" },
    { field: property.kitchen, label: "Kitchen" },
    { field: property.bathroom, label: "Bathroom" },
    { field: property.bedroom, label: "Bedroom" },
    { field: property.diningRoom, label: "Dining Room" },
    { field: property.veranda, label: "Veranda" },
    { field: property.googleEarthOne, label: "Google Earth One" },
    { field: property.googleEarthTwo, label: "Google Earth Two" },
    { field: property.masterPlanPhoto, label: "Master Plan" },
    { field: property.photo, label: "Property Photo" },
  ];

  imageFields.forEach(({ field, label }) => {
    if (field) {
      images.push({ url: field, label });
    }
  });

  return images;
};